import { actionCreators } from './actionCreators';
import { reducer } from './reducer';

const tableMapsStore = {
    actionCreators,
    reducer,
};

export default tableMapsStore;
